import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_SYSTEM_ROLE_LIST,
    CLEAR_SYSTEM_ROLE_LIST_ERROR,
    LOAD_SYSTEM_ROLE_LIST_REQUEST,
    LOAD_SYSTEM_ROLE_LIST_SUCCESS,
    LOAD_SYSTEM_ROLE_LIST_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_SYSTEM_ROLE_LIST,
    CLEAR_ERROR: CLEAR_SYSTEM_ROLE_LIST_ERROR,
    LOAD_REQUEST: LOAD_SYSTEM_ROLE_LIST_REQUEST,
    LOAD_SUCCESS: LOAD_SYSTEM_ROLE_LIST_SUCCESS,
    LOAD_FAILURE: LOAD_SYSTEM_ROLE_LIST_FAILURE
}